import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../../services/admin.service';
import { UserService } from '../../services/user.service';
import { Report } from '../../models/report.model';
import { ROUTE_ID_PARAM } from './my-working-report.constants';
import { StoredReportUser } from './my-working-report.types';

@Injectable()
export class MyWorkingReportDataSource {
  constructor(
    private adminService: AdminService,
    private userService: UserService,
    private route: ActivatedRoute
  ) {
  }

  public routeUserId(): string {
    return this.route.snapshot.params[ROUTE_ID_PARAM];
  }

  public currentUser(): StoredReportUser {
    return <StoredReportUser>this.userService.getLocal();
  }

  public user(userId: string): Observable<Object> {
    return this.adminService.getChtoto(userId);
  }

  public vacation(userId: string): Observable<Object> {
    return this.userService.getVocation(userId);
  }

  public workDays(userId: string, from: string, to: string): Observable<Object> {
    return this.adminService.getWorkDays(userId, from, to);
  }

  public karma(userId: string, from: string, to: string): Observable<Object> {
    return this.adminService.getKarmaInfo(userId, from, to);
  }

  public excel(reports: Report[], groupName: string): Observable<Object> {
    return this.adminService.getExcelReport(reports, groupName);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/my-working-report/my-working-report-data.source.ts